import { render, staticRenderFns } from "./RoomDamageQuoteForm.vue?vue&type=template&id=2db187a6&scoped=true"
import script from "./RoomDamageQuoteForm.vue?vue&type=script&lang=ts"
export * from "./RoomDamageQuoteForm.vue?vue&type=script&lang=ts"
import style0 from "./RoomDamageQuoteForm.vue?vue&type=style&index=0&id=2db187a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db187a6",
  null
  
)

export default component.exports